export default "__VITE_ASSET__DYV89Jgm__"